// extracted by mini-css-extract-plugin
module.exports = {"receiptItem":"receipt-item-fragment_receiptItem_35Lq6"};